export default __webpack_public_path__ + "static/d9ece20769da60a511558cf054734fc8.svg";